import { compareNameUkStrings } from "./sortUk";

/**
 * Побудова структури для <select> з <optgroup> за flat-списком категорій з parentId.
 * Лист = назва, що зберігається в Transaction.category.
 * Порядок у списку — алфавітний uk (ігноруємо order з БД, щоб випадаємий список був передбачуваним).
 */
export function groupCategoriesForSelect(rows) {
    if (!Array.isArray(rows) || !rows.length) {
        return [];
    }

    const byId = new Map(rows.map((r) => [String(r._id), r]));

    const childrenOf = (pid) =>
        rows
            .filter((r) => r.parentId && String(r.parentId) === String(pid))
            .sort((a, b) => compareNameUkStrings(a.name, b.name));

    const roots = rows
        .filter((r) => !r.parentId)
        .sort((a, b) => compareNameUkStrings(a.name, b.name));

    const options = [];

    for (const root of roots) {
        const kids = childrenOf(root._id);
        if (kids.length > 0) {
            options.push({
                kind: "group",
                label: root.name,
                items: kids.map((k) => ({ value: k.name, label: k.name })),
            });
        } else {
            options.push({ kind: "option", value: root.name, label: root.name });
        }
    }

    const orphans = rows.filter(
        (r) => r.parentId && !byId.get(String(r.parentId))
    );
    for (const o of orphans.sort((a, b) => compareNameUkStrings(a.name, b.name))) {
        options.push({
            kind: "option",
            value: o.name,
            label: `${o.name} (група недоступна)`,
        });
    }

    return options;
}

export function collectKnownValuesFromGroups(groups) {
    const s = new Set();
    for (const g of groups) {
        if (g.kind === "option") s.add(g.value);
        if (g.kind === "group") {
            for (const it of g.items || []) s.add(it.value);
        }
    }
    return s;
}
